var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from "react";
import { Spacing } from "../../core/constants";
import { getValidChildren } from "../../core/utils";
import Box from "../Box";
function ButtonGroup(_a) {
    var { size, colorScheme, variantColor, variant, spacing = 2, children, isFullWidth } = _a, rest = __rest(_a, ["size", "colorScheme", "variantColor", "variant", "spacing", "children", "isFullWidth"]);
    const isAttached = spacing === Spacing[0];
    const validChildren = getValidChildren(children);
    const clones = validChildren.map((child, index) => {
        const isFirst = index === 0;
        const isLast = index === validChildren.length - 1;
        return cloneElement(child, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ size: size || child.props.size, colorScheme: child.props.colorScheme ||
                colorScheme ||
                child.props.variantColor ||
                variantColor, variant: child.props.variant || variant, _focus: { boxShadow: "outline", zIndex: 1 }, flex: isFullWidth ? 1 : undefined }, (!isLast && !isAttached && { mr: spacing })), (isFirst && isAttached && { roundedRight: 0 })), (isLast && isAttached && { roundedLeft: 0 })), (!isLast && isAttached && { borderRight: 0 })), (!isFirst && !isLast && isAttached && { rounded: 0 })));
    });
    return (React.createElement(Box, Object.assign({ display: isFullWidth ? "flex" : "inline-flex" }, rest), clones));
}
ButtonGroup.displayName = "ButtonGroup";
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map